import type { JSX } from "react";
import { useEffect, useState } from "react";

import useWindowSize from "~/hooks/useWindowSize";

declare global {
  interface Window {
    fwSettings?: { widget_id: number };
  }
}

const FRESHWORKS_WIDGET_ID = 157000001297;

const HelpDeskScript = (): JSX.Element | null => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [windowWidth] = useWindowSize();

  useEffect(() => {
    // Inject fwSettings and FreshworksWidget stub
    if (!window.fwSettings) {
      window.fwSettings = { widget_id: FRESHWORKS_WIDGET_ID };
    }
    if (typeof window.FreshworksWidget !== "function") {
      const n = function (...args: any[]) {
        n.q.push(args);
      } as {
        (...args: any[]): void;
        q: any[][];
      };
      n.q = [];
      window.FreshworksWidget = n;
    }

    // Inject the Freshworks script if not already present
    if (!document.getElementById("freshworks-script")) {
      const script = document.createElement("script");
      script.id = "freshworks-script";
      script.src = `https://widget.freshworks.com/widgets/${FRESHWORKS_WIDGET_ID}.js`;
      script.async = true;
      script.onload = () => setIsLoaded(true);
      document.body.appendChild(script);
    } else {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (isLoaded && window.FreshworksWidget) {
      window.FreshworksWidget("hide", "launcher");
    }
  }, [isLoaded, windowWidth]);

  return null;
};

export default HelpDeskScript;
